﻿// JS Dependencies: Bootstrap & JQuery
import 'bootstrap';
import 'jquery';
// Using the next two lines is like including partial view _ValidationScriptsPartial.cshtml
import 'jquery-validation';
import 'jquery-validation-unobtrusive';

import 'bootstrap/dist/css/bootstrap.css';
import '../styles/main.scss';

import $ from 'jquery';

$(document).ready(function () {
    $("#docuSelectVersion").on("change", function () {
        var url = window.location.origin + '/Docu/' + $(this).val();
        window.location.href = url;
    });

    $("#docuSearch").on("input", function () {
        var val = $(this).val();
        $(".docu-nav a").each(function () {
            var text = $(this).text();
            if (val == '' || text.toLowerCase().includes(val)) {
                $(this).show()
            } else {
                $(this).hide()
            }
        })
    })
});
